import React from 'react';

const DashboardHeader = ({ title }) => {
  return (
    <div className='col-sm-12 col-md-12 margin_bottom_20'>
      <h1 className='section_head'>{title}</h1>
    </div>
  );
};

export default DashboardHeader;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/DashboardHeader.jsx